module.exports = __webpack_public_path__ + "img/intelligent.baee7bd1.png";